import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction } from "@inmagik/react-crud"
import type { Output } from "../types"
import { API_URL } from "../constants"

export function useOutputsList(params: Record<string, string> = {}) {
  return useList<Output>(`${API_URL}/admin/outputs`, {
    query: params,
  })
}

export function useOutput(id: number | undefined) {
  return useDetail<Output>(`${API_URL}/admin/outputs`, id?.toString())
}

export function useCreateOutput() {
  return useCreate<Output>(`${API_URL}/admin/outputs`, {
    encode: "formdata",
  })
}

export function useUpdateOutput() {
  return useUpdate<Output>(`${API_URL}/admin/outputs`, {
    encode: "formdata",
  })
}

export function useDeleteOutput() {
  return useDelete(`${API_URL}/admin/outputs`)
}

export function usePartialUpdateOutput() {
  return usePartialUpdate<Output>(`${API_URL}/admin/outputs`, {
    encode: "formdata",
  })
}

export function useDeleteMultiOutput() {
  return useAction(`${API_URL}/admin/outputs/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}